import React from 'react';
import { GWITracker } from 'gwi-tracker';
import PropTypes from 'prop-types';
import Star from './star';
import logger from '../../../shared/helpers/logger';
import FrameEventService from '../../../shared/services/frame-event-service';

class Rating extends React.Component {

  static propTypes = {
    /*eslint-disable */
    brickData: PropTypes.object.isRequired,
    /*eslint-enable */
    onRate: PropTypes.func.isRequired,
    onErasedRating: PropTypes.func.isRequired,
  };

  state = {
    hoverAt: null,
    numberOfStars: 5,
  };

  handleMouseOver = (idx) => {
    this.setState({ hoverAt: idx + 1 });
  };

  handleMouseLeave = () => {
    this.setState({ hoverAt: null });
  };

  handleRate = (rating) => {
    const brickData = this.props.brickData;
    const { watchableType, watchableId } = brickData;

    if (brickData.isLoggedIn) {
      logger.debug('User logged in, trying to rate now..');

      brickData.api.setUserRating(watchableType, watchableId, rating).then((data) => {
        logger.debug('Successfully rated ', rating, data);

        // ***
        GWITracker.trackRate(brickData.trackingState, rating);
        // ***

        this.props.onRate(rating);
      }, (xhr, status, err) => {
        logger.error('API call to rate failed.', xhr, status, err);
      });
    } else {
      logger.warn('Not Logged in..');

      logger.debug('Firing Frame Messenger for add rating');

      FrameEventService.sendSignInRequired(brickData);
    }
  };

  clearRating = () => {
    const brickData = this.props.brickData;
    const { watchableType, watchableId } = brickData;

    brickData.api.eraseUserRating(watchableId, watchableType).then(() => {
      // ****
      GWITracker.trackUnRate(brickData.trackingState);
      // ****

      this.props.onErasedRating();
    });
  };

  renderRateableStars() {
    const stars = [];

    for (let i = 0; i < this.state.numberOfStars; i += 1) {
      const newRating = this.state.hoverAt != null ?
          this.state.hoverAt : this.props.brickData.userRating || this.props.brickData.rating;
      const selected = (i < newRating);

      stars.push(
          Star({
            key: i,
            selected,
            onMouseOver: () => { this.handleMouseOver(i); },
            onMouseLeave: () => { this.handleMouseLeave(); },
            onClick: () => { this.handleRate(i + 1); },
          }),
      );
    }

    return stars;
  }

  renderReadOnlyStars() {
    const stars = [];

    for (let i = 0; i < this.state.numberOfStars; i += 1) {
      const selected = (i < this.props.brickData.rating);

      stars.push(
          Star({
            key: i,
            selected,
          }),
      );
    }

    return stars;
  }

  render() {
    const stars = this.props.brickData.hideUserActions ?
        this.renderReadOnlyStars() : this.renderRateableStars();
    const ratingOrRatings = parseInt(this.props.brickData.numberOfRatings, 10) === 1 ? ' rating' : ' ratings';

    return (
      <div className={this.props.brickData.hideUserActions ? 'rating' : 'rating rateable'}>
        {stars}
        <span className="rating-label">
          {
            this.props.brickData.userRating ?
              <span><button className="rating-clear" onClick={this.clearRating}>clear</button></span> :
              <span className="rating-count">{this.props.brickData.numberOfRatings}
                <span className="rating-count-word">{ratingOrRatings}</span></span>
          }
        </span>
      </div>
    );
  }
}

export default Rating;



// WEBPACK FOOTER //
// ./src/client/components/rating/rating.jsx